"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* Button components

  @desc - Display rules

  1. Strict Padding Mode:
      Top & Bottom Padding the same , calculated based on (targetWidth - lineHeight)/2
       Left & Right Padding = strict padding X 1.5
  2. Relaxed Padding mode: Padding Width  = strict padding X3
  3. Circle Buttons with label gets default white color (always).
  4. Fullwidth makes width 100% of container

*/


var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var polished_1 = require("polished");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var ButtonSettings_1 = require("./ButtonSettings");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_layout_2 = require("@ryerson/frontend.layout");

var react_2 = require("@emotion/react");

var Button = function Button(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? "square" : _ref$shape,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$foreground = _ref.foreground,
      foreground = _ref$foreground === void 0 ? "dark" : _ref$foreground,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "solid" : _ref$variant,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "center" : _ref$align,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      background = _ref.background,
      label = _ref.label,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? "" : _ref$dataTestId,
      _ref$circleLabelOrien = _ref.circleLabelOrient,
      circleLabelOrient = _ref$circleLabelOrien === void 0 ? "left" : _ref$circleLabelOrien,
      _ref$paddingType = _ref.paddingType,
      paddingType = _ref$paddingType === void 0 ? "strict" : _ref$paddingType,
      _ref$fullwidth = _ref.fullwidth,
      fullwidth = _ref$fullwidth === void 0 ? false : _ref$fullwidth,
      onClick = _ref.onClick,
      _onFocus = _ref.onFocus,
      tabIndex = _ref.tabIndex,
      sizePassedIn = _ref.size;
  var showDebugBorders = false;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme,
      themeName = _ref2.themeName;

  var _theme$colors$primary = theme.colors.primary,
      disable = _theme$colors$primary.disable,
      white = _theme$colors$primary.white,
      lightGray = _theme$colors$primary.lightGray,
      darkerGray = _theme$colors$primary.darkerGray,
      primaryBrand = _theme$colors$primary.primaryBrand,
      accentBrand = _theme$colors$primary.accentBrand,
      secondaryBrand = _theme$colors$primary.secondaryBrand;
  var hasSize = !!sizePassedIn;
  var disabledColor = disable;
  var hasColor = !!background;
  var selectedCursor = disabled ? "default" : "pointer";
  var isCircle = !!(shape === "circle");
  var isRounded = !!(shape === "rounded");
  var isSquare = !!(shape === "square");
  var isSolid = !!(variant === "solid");
  var isOutline = !!(variant === "outline");
  var circOrientRight = !!(circleLabelOrient === "right");
  var circOrientLeft = !!(circleLabelOrient === "left");
  var isSquareish = !!(isRounded || isSquare);
  var hasLabel = !!label;
  var hasIcon = !!leftIcon || !!rightIcon;
  var isIconOnly = !hasLabel && hasIcon;
  var isAlignSpace = !!(align === "space");
  var isStrictPadding = !!(paddingType === "strict");
  var fontsizes = Object.assign({}, theme.typography.fonts.sizes);
  !hasColor && (type === "primary" && (background = accentBrand) || type === "secondary" && (background = primaryBrand) || type === "tertiary" && (background = secondaryBrand));
  var settings = Object.assign({}, ButtonSettings_1.settings); // Temp fix for Primary color. Refactor later ask Dan and Sal

  settings.textColor = {
    primary: themeName === frontend_theme_1.ThemeNames.southernToolSteel ? white : darkerGray,
    secondary: white,
    tertiary: white,
    default: darkerGray
  };
  settings.textHueSetting = {
    light: white,
    dark: darkerGray,
    default: darkerGray
  };
  var hoverMixColor = background === white ? lightGray : white;
  settings.hoverColor = {
    solid: (0, polished_1.mix)(0.65, background || "", hoverMixColor),
    outline: (0, polished_1.mix)(0.1, background || "", hoverMixColor),
    default: (0, polished_1.mix)(0.65, background || "", hoverMixColor)
  };
  var backgroundColor = disabled ? disabledColor : background;
  var foregroundColor = settings.textHueSetting[foreground] || settings.textHueSetting.default;
  var textColor = hasColor && isSolid && foregroundColor || !isSolid && background || settings.textColor[type] || settings.textColor.default;
  var outLineColor = background || settings.bgColor.default;
  var typographySize = settings.typographySize[size] || settings.typographySize.default;
  var iconSize = settings.iconSize[size] || settings.iconSize.default;
  var minWidth = "";
  var minHeight = "";

  if (isCircle) {
    minWidth = settings.circMinWidth[size] || settings.circMinWidth.default;
    minHeight = settings.minHeight[size] || settings.minHeight.default;
  } else if (isSquareish && isIconOnly) {
    minWidth = settings.squareIconOnlyWidth[size] || settings.squareIconOnlyWidth.default;
    minHeight = settings.squareIconOnlyHeight[size] || settings.squareIconOnlyHeight.default;
  } else if (isRounded) {
    minHeight = settings.roundedButtonHeights[size] || settings.roundedButtonHeights.default;
  } else if (isSquare) {
    minHeight = settings.squareMinHeight[size] || settings.squareMinHeight.default;
  }

  var calcPadding = function calcPadding() {
    var targetHeight = parseInt(minHeight);
    var lineHeight;

    if (isIconOnly) {
      lineHeight = parseInt(new frontend_assets_1.SizeList()[iconSize]);
    } else {
      lineHeight = parseInt(fontsizes[typographySize].lineHeight);
    }

    var padAmount = (targetHeight - lineHeight) / 2;
    isOutline && (padAmount = padAmount - 1);
    return "".concat(padAmount, "px");
  };

  var getlabelSidePadding = function getlabelSidePadding() {
    var labelSectionPadding = "";

    if (isSquare && isIconOnly) {
      labelSectionPadding = "0px 0px";
    } else if (isSquareish) {
      labelSectionPadding = isStrictPadding ? "0px ".concat(parseInt(calcPadding()) * 1.5, "px") : "0px ".concat(parseInt(calcPadding()) * 3, "px");
    }

    return labelSectionPadding;
  };

  var borderRadius = shape === "square" ? "2px" : shape === "rounded" ? settings.borderRadiusrounded[size] || settings.borderRadiusrounded.default : "50%";
  var ButtonRoot = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tdisplay: block;\n\t"])));
  var hoverBackgroundStyle = "\n      :hover {\n      background-color: ".concat(!disabled && settings.hoverColor[variant], "!important;\n    }\n");
  var ButtonMain = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tdisplay: inline-block;\n\t\t", ";\n\t"])), hoverBackgroundStyle);
  var LabelSection = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tdisplay: flex;\n\t\tuser-select: none;\n\t\tjustify-content: ", ";\n\t\t", "\n\t"])), align === "right" ? "flex-end" : align === "space" ? "space-between" : align, showDebugBorders && " border:1px solid red;");
  var ButtonContent = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t", "\n\t\tmargin:auto;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t"])), showDebugBorders && " border:1px solid red;");
  var IconWrapper = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\t", "\n\t\t", " \n    ", ";\n\t\t", "\n\t"])), isCircle && "position:relative;", isCircle && "top:".concat(settings.cicleIconTop[size], ";") || "top:0px;", !isCircle && !isIconOnly && "padding: 0px 10px", showDebugBorders && " border:1px solid yellow;");
  var LeftIconWrapper = (0, styled_1.default)(IconWrapper)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t", "\n\t\t", "\n\t"])), !isCircle ? "padding-left : 0px;" : "", isAlignSpace && !fullwidth && "padding:0px 5px;");
  var RightIconWrapper = (0, styled_1.default)(IconWrapper)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t", "\n\t\t", "\n\t"])), !isCircle ? "padding-right : 0px;" : "", isAlignSpace && !fullwidth && "padding:0px 5px;");
  var TypeOuter = styled_1.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\tjustify-content: center;\n\t\t", "\n\t"])), showDebugBorders && "border:1px solid blue;");
  var TypeInner = styled_1.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\tjustify-content: center;\n\t"])));
  var CircleLabelOuter = styled_1.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\tpadding-top: 2px;\n\t\tcursor: ", ";\n\t\t", "\n\t\t", ";\n\t"])), selectedCursor, showDebugBorders && "border:1px solid blue;", circOrientRight && "padding-left:18px;" || "padding-right:18px;");
  var CircleTypeInner = styled_1.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t", ";\n\t\t", ";\n\t\tline-break: auto;\n\t\tword-break: normal;\n\t\tcursor: inherit;\n\t"])), circOrientRight && "text-align:left;", circOrientLeft && "text-align:right;");

  var _ref3 = (0, react_1.useState)(react_1.default.createRef()),
      _ref4 = _slicedToArray(_ref3, 1),
      domNodeRef = _ref4[0];

  var onButtonClick = function onButtonClick(event) {
    event.detail === 1 && onClick(event);
  };

  var renderIcon = function renderIcon(iconStr) {
    var _a;

    var mappedSize = settings.typographySize[size];
    var lineHeight = parseInt((_a = fontsizes[mappedSize]) === null || _a === void 0 ? void 0 : _a.size);
    return (0, jsx_runtime_1.jsx)(frontend_layout_2.Flex, {
      className: "icon-wrapper-outer",
      alignItems: "flex-start",
      css: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\t\tpointer-events: none;\n\t\t\t\t\theight: ", "px;\n\t\t\t\t\twidth: ", "px;\n\t\t\t\t"])), lineHeight, lineHeight),
      children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        className: "icons-size-".concat(iconSize),
        icon: iconStr,
        color: isCircle && hasLabel ? white : textColor,
        disabledColor: variant === "outline" ? disabledColor : white,
        size: "fit",
        disabled: disabled,
        onClick: onButtonClick
      })
    });
  };

  var renderLabelSection = function renderLabelSection(isMobile) {
    var typeSize = typographySize;
    return (0, jsx_runtime_1.jsxs)(LabelSection, {
      className: "label-section",
      style: {
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        padding: getlabelSidePadding()
      },
      children: [leftIcon && (0, jsx_runtime_1.jsxs)(LeftIconWrapper, {
        children: [renderIcon(leftIcon), " "]
      }), label && !isCircle && (0, jsx_runtime_1.jsx)(TypeOuter, {
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          autoResize: false,
          color: disabled && variant === "solid" ? white : disabled && variant === "outline" ? disabledColor : textColor,
          variant: "div",
          size: typeSize,
          children: (0, jsx_runtime_1.jsxs)(TypeInner, {
            className: "type-inner",
            children: [" ", label]
          })
        })
      }), rightIcon && (0, jsx_runtime_1.jsxs)(RightIconWrapper, {
        children: [" ", renderIcon(rightIcon), " "]
      })]
    });
  };

  var renderCircleLabel = function renderCircleLabel(isMobile) {
    var useMobileDefaults = isMobile && isSquare && !isIconOnly && !hasSize;
    var typeSize = useMobileDefaults ? settings.typographySize.mobileDefault : typographySize;
    return (0, jsx_runtime_1.jsx)(CircleLabelOuter, {
      onClick: !disabled ? onButtonClick : undefined,
      className: "circle-label-outer",
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        weight: "bold",
        color: disabled && isSolid ? white : disabled && isOutline ? disabledColor : textColor,
        variant: "span",
        size: typeSize,
        children: (0, jsx_runtime_1.jsxs)(CircleTypeInner, {
          className: "type-inner",
          children: [" ", label]
        })
      })
    });
  };

  var getMainStyle = function getMainStyle(minWidth, minHeight, isMobile) {
    var styleObj = {
      cursor: selectedCursor,
      backgroundColor: isSolid && (backgroundColor || ""),
      border: isOutline && "1px solid ".concat(disabled ? disabledColor : outLineColor) || 0,
      borderRadius: borderRadius,
      minWidth: isCircle ? minWidth : null,
      width: isCircle ? minWidth : fullwidth ? "100%" : "auto",
      height: isCircle ? minWidth : "auto",
      paddingTop: "",
      paddingBottom: "",
      paddingLeft: "",
      paddingRight: ""
    };
    isSquareish && (styleObj = Object.assign(Object.assign({}, styleObj), {
      paddingTop: calcPadding(),
      paddingBottom: calcPadding()
    }));
    isSquareish && isIconOnly && (styleObj = Object.assign(Object.assign({}, styleObj), {
      paddingLeft: calcPadding(),
      paddingRight: calcPadding()
    }));
    return styleObj;
  };

  return (0, jsx_runtime_1.jsxs)(ButtonRoot, {
    "data-testid": dataTestId,
    className: "button-component-root ".concat(className && (className || "")),
    ref: domNodeRef,
    style: {
      color: textColor
    },
    onClick: !disabled && isSquare ? onButtonClick : undefined,
    "aria-disabled": disabled ? true : false,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_2.Flex, {
        alignItems: "center",
        children: [isCircle && hasLabel && circOrientLeft && renderCircleLabel(), (0, jsx_runtime_1.jsx)(ButtonMain, {
          onClick: !disabled && !isSquare ? onButtonClick : undefined,
          style: getMainStyle(minWidth, minHeight, true),
          children: (0, jsx_runtime_1.jsx)(ButtonContent, {
            style: {
              borderRadius: borderRadius
            },
            children: renderLabelSection(true)
          })
        }), isCircle && hasLabel && circOrientRight && renderCircleLabel()]
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_2.Flex, {
        alignItems: "center",
        children: [isCircle && hasLabel && circOrientLeft && renderCircleLabel(), (0, jsx_runtime_1.jsx)(ButtonMain, Object.assign({
          className: "".concat(className ? className : ""),
          onClick: !disabled && !isSquare ? onButtonClick : undefined,
          style: getMainStyle(minWidth, minHeight, false)
        }, typeof tabIndex !== "undefined" ? {
          tabIndex: tabIndex
        } : {}, {
          role: "button",
          onFocus: function onFocus(e) {
            _onFocus && _onFocus(e);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter" && typeof tabIndex !== "undefined") {
              onClick(e);
            }
          },
          children: (0, jsx_runtime_1.jsx)(ButtonContent, {
            style: {
              borderRadius: borderRadius
            },
            children: renderLabelSection(false)
          })
        })), isCircle && hasLabel && circOrientRight && renderCircleLabel()]
      })
    })]
  });
};

exports.default = Button;